import {
  Box,
  Center,
  chakra,
  // CircularProgress,
  Flex,
  Text,
} from '@chakra-ui/react'
import { FC, useEffect } from 'react'
import { ContentPdfAIProps, useContentPdfAI } from '../ContentPdfAI/hook'

const TextHidden = chakra('span', {
  baseStyle: {
    display: 'inline-block',
    textIndent: '-9999px',
    whiteSpace: 'pre',
  },
})
/**
 * AIAdvice molecules
 * @constructor
 */
export const ContentPdfAIReport: FC<ContentPdfAIProps> = props => {
  const {
    company,
    data,
    error,
    handleSetPagePdf,
    loading,
    block,
    pdfPage,
    baseNewsId,
    selectedNewsId,
    isDetailModalOpen,
  } = useContentPdfAI(props)

  const pages = pdfPage?.split(',').map(Number)
  const pageData = data.find(
    item =>
      item.pages.length === pages?.length &&
      item.pages.every((v, i) => v === pages[i]),
  )

  useEffect(() => {
    const blockIndex = Number(block) - 1
    if (!isNaN(blockIndex) && blockIndex >= 0 && blockIndex < data.length) {
      const blockItem = data[blockIndex]
      if (blockItem?.pages?.length > 0) {
        handleSetPagePdf(blockItem.pages[0].toString(), true)
      }
    }
  }, [block, data, handleSetPagePdf])

  if (loading) {
    return (
      <Center my="50px">
        <Text
          color="#000000"
          fontSize="sm"
          fontWeight="bold"
          textTransform="uppercase"
        >
          要約の生成に時間がかかっています。しばらくしてから再度お試しください。
        </Text>
      </Center>
    )
  } else if (error) {
    return (
      <Center>
        <Text
          color="#000000"
          fontSize="sm"
          fontWeight="bold"
          textTransform="uppercase"
        >
          要約の生成に時間がかかっています。しばらくしてから再度お試しください。
        </Text>
      </Center>
    )
  } else if (!data.length) {
    return (
      <Center>
        <Text>データがありません。</Text>
      </Center>
    )
  }

  return (
    <Box boxSizing="border-box" w="100%">
      <Flex gap={3}>
        <Box w="100%">
          <Box
            color="black.100"
            fontSize="sm"
            fontWeight="normal"
            id="text-element"
            lineHeight="shorter"
            textAlign="justify"
            whiteSpace={'pre-wrap'}
          >
            {!pdfPage && !block
              ? data &&
                data.map((it, key) => (
                  <Text key={key} lineHeight="24.5px">
                    <strong>{key + 1}. </strong>
                    <strong>{it?.important_point} </strong>
                    {it?.summary}
                    {it?.pages && (
                      <>
                        <TextHidden>【引用元：</TextHidden>
                        {it.pages.map((i: any, idx: number) => (
                          <Text key={`pdf_page_${idx}`} as={'span'}>
                            {i && (
                              <Text
                                alignItems="center"
                                as={'span'}
                                backgroundColor="#6FB0ED"
                                borderRadius="24px"
                                color="#fff"
                                cursor="pointer"
                                display="inline-flex"
                                height="20px"
                                justifyContent="center"
                                ml="4px"
                                w="24px"
                                onClick={() => {
                                  baseNewsId !== selectedNewsId ||
                                  (baseNewsId === selectedNewsId &&
                                    isDetailModalOpen)
                                    ? window.open(
                                        `${
                                          window.location.origin
                                        }/dashboard/post/${company?.news_id}?list_news_ai_id=${company?.list_news_ai_id}&company_id=${company?.company_id}&tab=0&pdf_page=${it.pages.join(
                                          ',',
                                        )}`,
                                        '_blank',
                                      )
                                    : handleSetPagePdf(i, true)
                                }}
                              >
                                {i}
                              </Text>
                            )}
                            {idx < it.pages.length - 1 && (
                              <TextHidden>,</TextHidden>
                            )}
                          </Text>
                        ))}
                        <TextHidden>】</TextHidden>
                      </>
                    )}
                  </Text>
                ))
              : data &&
                data.map((it, key) =>
                  it === pageData || key + 1 === Number(block) ? (
                    <Box key={key} lineHeight="20px" mb="8px">
                      <Box as="span" bg="#0084FF33" display="inline">
                        <strong>{key + 1}. </strong>
                        <strong>{it.important_point} </strong>
                        {it.summary}
                      </Box>
                      {it.pages?.map((i: any) => (
                        <Box
                          key={i}
                          alignItems="center"
                          as="span"
                          backgroundColor="#6FB0ED"
                          borderRadius="24px"
                          color="#fff"
                          cursor="pointer"
                          display="inline-flex"
                          justifyContent="center"
                          ml="4px"
                          verticalAlign="middle"
                          w="24px"
                          onClick={() => handleSetPagePdf(i, true)}
                        >
                          {i}
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Text key={key} lineHeight="24.5px">
                      <strong>{key + 1}. </strong>
                      <strong>{it?.important_point} </strong>
                      {it?.summary}
                      {it?.pages &&
                        it.pages.map((i: any) => (
                          <>
                            {i && (
                              <Text
                                alignItems="center"
                                as={'span'}
                                backgroundColor="#6FB0ED"
                                borderRadius="24px"
                                color="#fff"
                                cursor="pointer"
                                display="inline-flex"
                                height="20px"
                                justifyContent="center"
                                ml="4px"
                                w="24px"
                                onClick={() => handleSetPagePdf(i, true)}
                              >
                                {i}
                              </Text>
                            )}
                          </>
                        ))}
                    </Text>
                  ),
                )}
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}
